import {
  trimStart,
} from 'lodash';
import axios from 'axios';

export default (channel, handle) => {
  const options = {
    data: {
      platform: channel,
      name: trimStart(handle, '@'),
    },
  };

  if (handle.length === 0) {
    const details = {
      count: 0,
      error: false,
      thumbnail: '',
    };
    switch (channel) {
    case 'facebook':
      details.facebookpageName = null;
      details.facebookUserName = null;
      details.facebookVerified = false;
      break;
    case 'instagram':
      details.instagrampageName = null;
      details.instagramUserName = null;
      details.instagramVerified = false;
      break;
    case 'twitter':
      details.twitterpageName = null;
      details.twitterUserName = null;
      details.twitterVerified = false;
      break;
    case 'youtube':
      details.youtubeChannelTitle = null;
      details.youtubeChannelUserName = null;
      details.youtubeVerified = false;
      break;
    default: break;
    }
  }

  return axios
    .post(process.env.REACT_APP_GET_INFLUENCER_DATA_URL, options)
    .then(response => {
      const result = {
        count: response.data.body.data.followerCount,
        error: false,
        thumbnail: response.data.body.data.thumbnail,
      };

      const country = response.data.body.data.location;
      switch (channel) {
      case 'facebook':
        result.pageName = response.data.body.data.pagename;
        result.username = response.data.body.data.username;
        result.verified = response.data.body.data.verified;
        break;
      case 'instagram':
        result.pageName = response.data.body.data.full_name;
        result.username = response.data.body.data.username;
        result.verified = response.data.body.data.isVerified;
        break;
      case 'twitter':
        result.pageName = response.data.body.data.name;
        result.username = response.data.body.data.screen_name;
        result.verified = response.data.body.data.verified;
        break;
      case 'youtube':
        result.pageName = response.data.body.data.channelTitle;
        result.username = response.data.body.data.username;
        result.verified = response.data.body.data.verified;
        break;
      default: break;
      }
      result.thumbnail = response.data.body.data.thumbnail;
      result.country = country;
      result.shouldRenderSocialHandlesBlock = true;
      return result;
    });
};



/** WEBPACK FOOTER **
 ** ./src/utils/get-channel-data.js
 **/